import { Grid, Paper, Typography } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import IconButton from "@mui/material/IconButton";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

interface ICard {
  info: string | null;
  icon: JSX.Element;
  msg: string;
  type: string;
  edit(type: string): void;
}

export function Card(props: ICard) {
  const { info, icon, msg, type, edit } = props;

  const fontSize = {
    "@media (min-width:120px)": {
      fontSize: 12,
      // color: "black",
      fontWeight: "bold",
    },
    "@media (min-width:300px)": {
      fontSize: 14,
      // color: "purple",
      fontWeight: "bold",
    },
    "@media (min-width:400px)": {
      fontSize: 16,
      // color: "brown",
      fontWeight: "bold",
    },
    "@media (min-width:600px)": {
      fontSize: 18,
      // color: "red",
    },
    "@media (min-width:800px)": {
      fontSize: 18,
      // color: "orange",
    },
    "@media (min-width:1000px)": {
      fontSize: 18,
      // color: "violet",
    },
    "@media (min-width:1280px)": {
      fontSize: 20,
      // color: "green",
    },
  };

  return (
    <Grid item xs={12} xl={12} sx={{}}>
      <Paper sx={{ position: "relative" }}>
        {info ? (
          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            <IconButton
              onClick={() => edit(type)}
              id={type}
              sx={{
                position: "absolute",
                right: 3,
                top: 0,
              }}
            >
              <BorderColorIcon />
            </IconButton>
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1} sx={{ padding: 2 }}>
              {icon}
            </Grid>
            <Grid item xs={9} sm={9} md={9} lg={9} xl={9} sx={{}}>
              <Typography textAlign="left" sx={{ padding: 2, fontWeight: "bold", fontSize }}>
                {`${info}`}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            {" "}
            <IconButton
              onClick={() => edit(type)}
              id={type}
              sx={{
                position: "absolute",
                right: 3,
                top: 0,
              }}
            >
              <BorderColorIcon fontSize="large" />
            </IconButton>
            <Grid item xs={1} xl={1} sx={{ padding: 2 }}>
              <PriorityHighIcon fontSize="large" sx={{ marginRight: 2, color: "red" }} />
            </Grid>
            <Grid item xs={9} xl={9} sx={{}}>
              <Typography textAlign="left" variant="h6" sx={{ color: "red", padding: 2, alignItems: "center" }}>
                {msg}
              </Typography>
            </Grid>
          </Grid>
        )}
      </Paper>
    </Grid>
  );
}
